// extracted by mini-css-extract-plugin
export default {"switch":"ToggleSwitch_switch__YGtf7","input":"ToggleSwitch_input__NUuC+","sliderRound":"ToggleSwitch_sliderRound__-oOd6"};